import moment from "moment";
import { usersTypes } from "./constants";
import { get } from "lodash";

export const ArrayFromNumber = (number) => {
  return Array.from({ length: number }, (_, i) => i + 1);
};

export const isInstructor = (user) => {
  return user?.userType === usersTypes.instructor;
};
export const isAdmin = (user) => {
  return user?.userType === usersTypes.admin;
};
export const isStudent = (user) => {
  return user?.userType === usersTypes.student;
};
export const getValidDate = (date) => {
  const newDate = moment(date);
  if (!newDate.isValid()) return new Date();
  return newDate.toDate();
};

export const stringToHslColor = (str, s, l) => {
  var hash = 0;
  for (var i = 0; i < str?.length || 0; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  var h = hash % 360;
  return "hsl(" + h + ", " + s + "%, " + l + "%)";
};

export const getFilterList = (list = [], context = [], showLog = false) => {
  return (
    list?.filter((option) => {
      if (!option.filter) return true;
      const resp = Object.entries(option.filter).every(([filter, value]) => {
        let contextValue = get(context, filter);
        if (Array.isArray(value)) {
          const exclude = value.filter((item) => item.startsWith("!")).map((item) => item.slice(1));
          const include = value.filter((item) => !item.startsWith("!"));
          return (
            (include.length === 0 || include.includes(contextValue)) &&
            (exclude.length === 0 || !exclude.includes(contextValue))
          );
        }

        if (typeof value === "string") {
          if (value.startsWith("!")) return contextValue !== value.slice(1);
          return contextValue === value;
        }
        if (typeof value === "boolean") {
          return Boolean(contextValue) === value;
        }
        return false;
      });

      return resp;
    }) || []
  );
};

export const capitalizeAll = (s) => {
  if (typeof s !== "string") return "";
  return s
    .split(" ")
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(" ");
};
